<template>
  <v-layout justify-center>
    <v-flex>
      <v-card>
        <v-form v-model="valid" lazy-validation ref="form">
          <v-card-text>
            <v-layout wrap class="ma-2" v-if="appConfig">
              <v-flex xs12 sm4>
                <v-subheader>Icon</v-subheader>
              </v-flex>
              <v-flex xs12 sm8 v-if="appConfig.icon">
                <v-img contain max-height="200" :src="appConfig.icon" />
                <Storage v-model="appConfig.icon" type="appIcons" />
              </v-flex>
              <v-flex xs12>
                <v-expansion-panel class="my-4">
                  <v-expansion-panel-content
                    v-for="({ id, language }, i) of languages"
                    :key="i"
                    lazy
                  >
                    <template v-slot:header>
                      <div class="title">{{ id.toUpperCase() }} language</div>
                    </template>
                    <v-container fluid grid-list-xl>
                      <v-layout wrap>
                        <v-flex xs12 sm4>
                          <v-subheader>App Map</v-subheader>
                        </v-flex>
                        <v-flex xs12 sm8>
                          <ActionLink
                            v-model="language.appMapLink"
                            restrict="APP_MAP"
                          />
                        </v-flex>

                        <v-flex xs12 sm4>
                          <v-subheader>Is default language</v-subheader>
                        </v-flex>
                        <v-flex xs12 sm8>
                          <v-checkbox
                            v-model="language.isDefaultLanguage"
                            :disabled="language.isDefaultLanguage"
                            @change="checkDefaultLanguage(language)"
                          />
                        </v-flex>

                        <v-flex xs12 sm4>
                          <v-subheader>Main page</v-subheader>
                        </v-flex>
                        <v-flex xs12 sm8>
                          <ActionType
                            v-model="language.mainPageAction.type"
                            :only="['OPEN_PAGE', 'OPEN_SCANNER']"
                          />
                          <ActionLink
                            v-model="language.mainPageAction.link"
                            :type="language.mainPageAction.type"
                            :language="id"
                          />
                        </v-flex>

                        <v-flex xs12 sm4>
                          <v-subheader>First page link</v-subheader>
                        </v-flex>
                        <v-flex xs12 sm8>
                          <ActionLink
                            v-model="language.firstPageLink"
                            type="OPEN_PAGE"
                            :language="id"
                          />
                        </v-flex>

                        <v-flex xs12 sm4>
                          <v-subheader>Error page link</v-subheader>
                        </v-flex>
                        <v-flex xs12 sm8>
                          <ActionLink
                            v-model="language.errorPageLink"
                            type="OPEN_PAGE"
                            :language="id"
                          />
                        </v-flex>

                        <v-flex xs12 sm4>
                          <v-subheader>Name</v-subheader>
                        </v-flex>
                        <v-flex xs12 sm8>
                          <v-text-field
                            v-model="language.name"
                            :rules="[formRules.required]"
                          />
                        </v-flex>

                        <v-flex xs12 sm4>
                          <v-subheader>Notification channels</v-subheader>
                        </v-flex>
                        <v-flex xs12 sm8>
                          <v-layout
                            wrap
                            v-for="(key, i) of notificationChannelsKeys[id]"
                            :key="i"
                          >
                            <v-flex xs12 sm1>
                              <v-checkbox
                                v-model="
                                  notificationChannelsValues[id][i].isActive
                                "
                              />
                            </v-flex>
                            <v-flex xs12 sm4>
                              <v-text-field
                                label="Name"
                                v-model="notificationChannelsKeys[id][i]"
                                :rules="[formRules.required]"
                              />
                            </v-flex>
                            <v-flex xs12 sm5>
                              <v-text-field
                                label="Title"
                                v-model="
                                  notificationChannelsValues[id][i].title
                                "
                                :rules="[formRules.required]"
                              />
                            </v-flex>
                            <v-flex xs12 sm2>
                              <v-btn
                                @click="
                                  notificationChannelsKeys[id].splice(i, 1);
                                  notificationChannelsValues[id].splice(i, 1);
                                "
                                icon
                              >
                                <v-icon v-text="fa('trash-alt')"></v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>

                          <v-btn
                            block
                            @click="
                              notificationChannelsKeys[id].push('temp');
                              notificationChannelsValues[id].push({
                                isActive: true,
                                title: 'temp'
                              });
                            "
                          >
                            <v-icon v-text="fa('plus')"></v-icon> add
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
              <v-flex xs12 sm4>
                <v-subheader>New language</v-subheader>
              </v-flex>
              <v-flex xs12 sm8>
                <v-text-field
                  label="Language code"
                  v-model="newAppMapLanguageCode"
                />
                <v-btn
                  color="primary"
                  :disabled="!newAppMapLanguageCode"
                  :loading="loading"
                  @click="addLanguage"
                >
                  Add
                </v-btn>
              </v-flex>
              <v-flex xs12 sm4>
                <v-subheader>Style</v-subheader>
              </v-flex>
              <v-flex xs12 sm8>
                <ActionLink v-model="appConfig.themeLink" restrict="THEME" />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Supported framework version"
                  v-model="appConfig.supportedFrameworkVersion"
                  :rules="[formRules.required]"
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Version"
                  v-model="appConfig.version"
                  :rules="[formRules.required]"
                />
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              :disabled="!valid"
              color="primary"
              :loading="loading"
              @click="save"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import ActionLink from "../../components/ActionLink";
import ActionType from "../../components/ActionType";
import { db } from "../../plugins/firebase";
import { appConfig, eventHub } from "../../config/constants";
import Storage from "../../components/Storage";

export default {
  name: "AppConfigs",
  components: {
    ActionLink,
    ActionType,
    Storage
  },
  data: () => ({
    valid: false,
    loading: false,
    appConfig: null,
    notificationChannelsKeys: {},
    notificationChannelsValues: {},
    newAppMapLanguageCode: null
  }),
  firestore: {
    appConfig: db.collection("appConfigs").doc(appConfig)
  },
  methods: {
    checkDefaultLanguage(changedLanguage) {
      if (changedLanguage.isDefaultLanguage) {
        for (const { language } of this.languages) {
          if (language !== changedLanguage) {
            language.isDefaultLanguage = false;
          }
        }
      }
    },
    async save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.loading = true;
      const appConfig = this.appConfig;
      try {
        Object.keys(appConfig.languages).forEach(language => {
          appConfig.languages[
            language
          ].notificationChannels = this.notificationChannelsKeys[
            language
          ].reduce((notificationChannels, notificationChannelsKey, i) => {
            notificationChannels[
              notificationChannelsKey
            ] = this.notificationChannelsValues[language][i];
            return notificationChannels;
          }, {});
        });
        await db.runTransaction(async t =>
          t.set(this.$firestoreRefs.appConfig, appConfig)
        );
        eventHub.$emit("message", "green");
      } catch (error) {
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    },
    async addLanguage() {
      this.loading = true;
      const appConfig = this.appConfig;
      try {
        if (appConfig[this.newAppMapLanguageCode]) {
          new Error("Language Code already exist");
        }
        const newAppMapDoc = db.collection("appMaps").doc();
        appConfig.languages[this.newAppMapLanguageCode] = {
          name: appConfig.name,
          notificationChannels: {},
          appMapLink: {
            connector: "FIREBASE_FIRESTORE",
            path: "appMaps/" + newAppMapDoc.id
          },
          errorPageLink: {
            connector: "NONE",
            path: null
          },
          firstPageLink: {
            connector: "NONE",
            path: null
          },
          mainPageAction: {
            type: "NONE"
          },
          isDefaultLanguage: false
        };
        await db.runTransaction(async t =>
          t.set(this.$firestoreRefs.appConfig, appConfig).set(newAppMapDoc, {
            name: this.newAppMapLanguageCode,
            type: "APP_MAP",
            items: {
              "appConfigs/main": {
                cachingStrategy: "ALWAYS",
                isAuthenticationRequired: false,
                name: "main",
                type: "APP_CONFIG",
                version: 1
              },
              "themes/main": {
                cachingStrategy: "ALWAYS",
                isAuthenticationRequired: false,
                name: appConfig.name + " Theme",
                type: "THEME",
                version: 1
              }
            }
          })
        );
        eventHub.$emit("message", "green");
      } catch (error) {
        eventHub.$emit("message", "red", error.code);
      }
      this.newAppMapLanguageCode = null;
      this.loading = false;
    }
  },
  computed: {
    languages() {
      return Object.keys(this.appConfig.languages).map(language => ({
        id: language,
        language: this.appConfig.languages[language]
      }));
    }
  },
  watch: {
    appConfig(appConfig) {
      Object.keys(appConfig.languages).forEach(language => {
        this.$set(
          this.notificationChannelsKeys,
          language,
          Object.keys(appConfig.languages[language].notificationChannels)
        );
        this.$set(
          this.notificationChannelsValues,
          language,
          Object.values(appConfig.languages[language].notificationChannels)
        );
      });
    }
  }
};
</script>
